interface StepperProps {
  steps: string[];
  currentIndex: number;
}

export default function Stepper({ steps, currentIndex }: StepperProps) {
  return (
    <ol
      className="flex items-center w-full gap-2"
      aria-label="Wizard-Fortschritt"
    >
      {steps.map((label, i) => {
        const isDone = i < currentIndex;
        const isCurrent = i === currentIndex;
        return (
          <li key={i} className="flex items-center gap-2 flex-1">
            <div
              aria-current={isCurrent ? "step" : undefined}
              className={`
                w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold
                ${
                  isDone
                    ? "bg-emerald-600 text-white"
                    : isCurrent
                      ? "bg-brand-600 text-white ring-4 ring-brand-100"
                      : "bg-slate-200 text-slate-500"
                }
              `}
            >
              {isDone ? "✓" : i + 1}
            </div>
            <span
              className={`text-sm ${
                isCurrent
                  ? "font-medium text-slate-900"
                  : isDone
                    ? "text-slate-700"
                    : "text-slate-500"
              }`}
            >
              {label}
            </span>
            {i < steps.length - 1 && (
              <div
                aria-hidden="true"
                className={`flex-1 h-px ${
                  isDone ? "bg-emerald-300" : "bg-slate-200"
                }`}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
